import React, { useEffect, useState } from "react";
import {
    Button,
    Modal
} from "react-bootstrap";

export default function Agree() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>

            {/* <div className="custom-control custom-checkbox">
                <input type="checkbox" className="custom-control-input" id="defaultUnchecked"></input>
                <label className="custom-control-label" for="defaultUnchecked" onClick={handleShow} >       </label>
            </div> */}
            <div styel={{ alignItems: 'center' }}>
                <p onClick={handleShow} style={{ textDecoration: 'underline', textDecorationColor: '#0d6efd', marginBottom: '0', paddingLeft: '5px' }} > Agree To Terms   </p>
            </div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Terms of Service</Modal.Title>
                </Modal.Header>
                <Modal.Body>By clicking Adopt, I agree that the signature will be the electronic representation
                    of my signature for all purposes when I (or my agent) use them on documents,
                    including legally binding  just the same as a pen-and-paper signature or initial.</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    {/* <Button variant="primary" onClick={handleClose}>
                        Adopt
                    </Button> */}
                </Modal.Footer>
            </Modal>
        </>
    );
}

